import { Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
// ECharts optimized imports for tree shaking
import * as echarts from 'echarts/core';
import {
  PieChart
} from 'echarts/charts';
import {
  TooltipComponent,
  LegendComponent,
  TitleComponent
} from 'echarts/components';
import {
  CanvasRenderer
} from 'echarts/renderers';
import { ThemeService } from '../../service/theme-service';

// Register the required components
echarts.use([
  PieChart,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  CanvasRenderer
]);


@Component({
  selector: 'app-paper-submission-average-monthly',
  standalone:false,
  templateUrl: './paper-submission-average-monthly.html',
  styleUrls: ['./paper-submission-average-monthly.scss'],
})
export class PaperSubmissionAverageMonthly  implements OnInit, OnChanges {
  @Input() topicAvgObj!: any;
  @Input() average_paper_submission_per_months!: any[];
  private themeService = inject(ThemeService);
  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    this.piaChart(
      this.average_paper_submission_per_months,
      this.topicAvgObj
    );
  }

  ngOnInit() {}
  piaChart(average_paper_submission_per_months: any[], topicAvgObj:any): void {
    if (average_paper_submission_per_months.length > 0 && topicAvgObj) {
      const chartDom = document.getElementById('piaChartForPaperSubmissionMonthly')!;
      const theme = this.themeService.isDark() ? 'dark' : undefined;
      const myChart = echarts.init(chartDom, theme);
      const option = {
        backgroundColor: 'transparent',
        title: {
          text: topicAvgObj.title,
          left: 'center',
          textStyle: {
            color: this.themeService.isDark() ? '#e2e8f0' : '#333'
          }
        },
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            name: topicAvgObj.series_name,
            type: 'pie',
            radius: '50%',
            data: average_paper_submission_per_months,
            label: {
              color: this.themeService.isDark() ? '#cbd5e1' : '#333'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    }
  }
}

